document.addEventListener("DOMContentLoaded", () => {
  // Handle Currency Conversion in Announcement Messages
  const processAnnouncementMessages = () => {
    const messages = document.querySelectorAll(".js-announcement-text");
    if (!messages.length) return;
    if (
      !window._erj_ ||
      typeof window._erj_.convertUsdAndRoundUp !== "function" ||
      typeof window._erj_.getNoDecimalsFormat !== "function"
    )
      return;

    const noDecimalsFormat = window._erj_.getNoDecimalsFormat();
    const canFormatMoney = window.Shopify && typeof window.Shopify.formatMoney === "function";

    // Match a placeholder's USD amount against a presentment edge's `usd` and
    // reuse its local `edge` value; fall back to convertUsdAndRoundUp otherwise.
    const edges = typeof pbObject !== "undefined" && pbObject && Array.isArray(pbObject.edges) ? pbObject.edges : [];
    const findPresentmentAmount = (usdAmount) => {
      const match = edges.find(
        (edge) => edge && edge.presentment === true && edge.thresholdType !== "count" && Number(edge.usd) === usdAmount
      );
      if (!match) return null;
      const local = Number(match.edge);
      return Number.isFinite(local) ? local : null;
    };

    messages.forEach((msg) => {
      const rawText = msg.dataset.rawMessage;
      if (!rawText) return;
      // Match {number} placeholders, including values with commas/spaces.
      const regex = /\{([0-9][0-9.,\s]*)\}/g;
      let hasMatches = false;

      let newText = rawText.replace(regex, (match, numberStr) => {
        hasMatches = true;
        const normalizedNumber = numberStr.replace(/[\s,]/g, "");
        const isValidNumber = /^\d+(?:\.\d+)?$/.test(normalizedNumber);
        if (!isValidNumber) return match;

        const usdAmount = parseFloat(normalizedNumber);

        // Reuse the presentment threshold from pbObject when available, else convert.
        const presentmentAmount = findPresentmentAmount(usdAmount);
        const converted = presentmentAmount != null ? presentmentAmount : window._erj_.convertUsdAndRoundUp(usdAmount);

        // 3. Format the amount
        if (canFormatMoney) {
          // formatMoney expects cents; pass no-decimals format to drop the .00
          const formattedHtml = window.Shopify.formatMoney(converted * 100, noDecimalsFormat);
          // Strip HTML tags from formatted money (e.g., <span class="money">...</span>)
          // because we are inserting it as textContent or inside a simple text flow.
          return formattedHtml.replace(/<[^>]*>/gm, "");
        } else {
          // Fallback to basic string if formatMoney is not available
          return "$" + converted;
        }
      });

      if (hasMatches && newText !== rawText) {
        msg.innerHTML = newText;
      }

      // Re-bind CTA click events after innerHTML replacement
      const ctaElements = msg.querySelectorAll(".js-announcement-cta");
      ctaElements.forEach((cta) => {
        cta.addEventListener("click", function (e) {
          e.preventDefault();
          const customJs = this.dataset.customJs;
          if (customJs) {
            try {
              // Execute the custom JS string in a functional scope
              new Function(customJs)();
            } catch (err) {
              console.error("Error executing CTA custom JS:", err);
            }
          }
        });
      });
    });
  };

  // Header Top Rotating Messages
  const initRotatingMessages = () => {
    const rotatingContainer = document.querySelector(".rotating-messages");
    if (!rotatingContainer || rotatingContainer.dataset.rotationInitialized === "true") return;

    const topBarWrapper = document.querySelector(".top-bar-wrapper");
    const loopDelayRaw = topBarWrapper && topBarWrapper.dataset.loopDelay ? parseInt(topBarWrapper.dataset.loopDelay, 10) : 5000;
    const fadeDurationRaw = topBarWrapper && topBarWrapper.dataset.fadeDuration ? parseInt(topBarWrapper.dataset.fadeDuration, 10) : 1200;
    const loopDelay = Number.isFinite(loopDelayRaw) && loopDelayRaw >= 200 ? loopDelayRaw : 5000;
    const fadeDuration = Number.isFinite(fadeDurationRaw) && fadeDurationRaw >= 100 ? fadeDurationRaw : 1200;

    const messages = Array.from(rotatingContainer.querySelectorAll(".message"));
    if (messages.length <= 1) return;

    rotatingContainer.dataset.rotationInitialized = "true";
    rotatingContainer.style.setProperty("--announcement-fade-duration", `${fadeDuration}ms`);

    let currentIndex = 0;
    let pendingIndex = 0;
    let phase = "waiting";
    let timerId = null;

    const clearStates = (msg) => {
      msg.classList.remove("is-visible", "is-active");
    };

    const activateMessage = (msg) => {
      msg.classList.add("is-visible", "is-active");
    };

    messages.forEach(clearStates);
    activateMessage(messages[currentIndex]);

    const schedule = (delay) => {
      if (timerId) clearTimeout(timerId);
      timerId = window.setTimeout(runStateMachine, delay);
    };

    const runStateMachine = () => {
      const currentMsg = messages[currentIndex];

      if (phase === "waiting") {
        pendingIndex = (currentIndex + 1) % messages.length;
        phase = "fadingOut";
        currentMsg.classList.remove("is-active");
        schedule(fadeDuration);
        return;
      }

      if (phase === "fadingOut") {
        clearStates(currentMsg);
        const nextMsg = messages[pendingIndex];
        nextMsg.classList.add("is-visible");
        requestAnimationFrame(() => {
          nextMsg.classList.add("is-active");
        });
        currentIndex = pendingIndex;
        phase = "fadingIn";
        schedule(fadeDuration);
        return;
      }

      if (phase === "fadingIn") {
        phase = "waiting";
        schedule(loopDelay);
      }
    };

    schedule(loopDelay);
  };

  // Execute sequentially: first process messages, then initialize rotation
  processAnnouncementMessages();
  initRotatingMessages();

  // Handle country change. Delegated on `document` (rather than binding each
  // `.country-selector-link` individually) because the desktop country list
  // is now populated asynchronously by localization-picker.js from a shared
  // data island — direct binding at DOMContentLoaded time would miss links
  // that don't exist in the DOM yet.
  document.addEventListener("click", (e) => {
    const link = e.target.closest(".country-selector-link");
    if (!link) return;
    e.preventDefault();
    const isoCode = link.dataset.countryIso;
    const input = document.querySelector("#localization_form input[name='country_code']");
    if (input) {
      input.value = isoCode;

      // Klaviyo tracking logic port
      if (isoCode && typeof customerEmail !== "undefined" && customerEmail) {
        const payload = {
          data: {
            type: "profile",
            attributes: {
              email: customerEmail,
              properties: {
                preferred_country: isoCode,
                preferred_lang: window.Shopify && window.Shopify.localizationHVG ? window.Shopify.localizationHVG.languageIso : "",
              },
            },
          },
        };
        fetch("https://a.klaviyo.com/client/profiles/?company_id=Vd7qbT", {
          method: "POST",
          headers: {
            accept: "application/json",
            revision: "2024-07-15",
            "content-type": "application/json",
          },
          body: JSON.stringify(payload),
        }).catch((err) => console.error("Klaviyo tracking error:", err));
      }

      const form = document.querySelector("#localization_form");
      if (form) form.submit();
    }
  });

  // Handle currency change
  const currencyLinks = document.querySelectorAll(".currency-selector-link");
  currencyLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const isoCode = this.dataset.currencyIso;
      const select = document.querySelector("#currency_form select");
      if (select) {
        select.value = isoCode;
        const form = document.querySelector("#currency_form");
        if (form) form.submit();
      }
    });
  });
});
